import Api from '@/api'
import File from '@/models/File'

export default {
  namespaced: true,
  state: {
    files: [],
    filesMeta: {
      current_page: 1
    },
    infoTypes: [],
    currentScreen: 'New',
    file: null
  },

  mutations: {
    setInfoTypes(state, infoTypes) {
      state.infoTypes = infoTypes
    },

    clearInfoTypes(state) {
      state.infoTypes = null
    },

    setCurrentScreen(state, currentScreen) {
      state.currentScreen = currentScreen
    },

    clearCurrentScreen(state) {
      state.currentScreen = null
    },

    setFiles(state, files) {
      state.files = files
    },

    setFilesMeta(state, meta) {
      state.filesMeta = meta
    },

    clearFiles(state) {
      state.files = []
    },

    clearFilesMeta(state) {
      state.filesMeta = {
        current_page: 1
      }
    },

    setFile(state, file) {
      if (file instanceof File) {
        state.file = file
      } else {
        state.file = new File(file)
      }
    },

    clearFile(state) {
      state.file = null
    }
  },

  actions: {
    async getInfoTypes({ commit }) {
      const { data } = await Api.get(`information-types`)
      commit('setInfoTypes', data.data)
    },

    async getFiles({ commit }, page) {
      const { data } = await Api.get(`file?page=${page}`)
      commit('clearFiles')
      commit('clearFilesMeta')

      if (data) {
        commit('setFiles', data.data)
        commit('setFilesMeta', data.meta)
      }
    },

    async getFile({ commit }, id) {
      const { data } = await Api.get(`file/${id}`)
      commit('setFile', data.data)
    },

    async getSearchedFiles({ commit }, name) {
      const file = new File()
      const { data } = await file.where('search', name).get()
      commit('clearFiles')

      if (data) {
        commit('setFiles', data)
      }
    },

    async getValidFiles({ commit }, name) {
      const file = new File()
      const { data } = await file.where('status', 'valid').get()
      commit('clearFiles')

      if (data) {
        commit('setFiles', data)
      }
    },

    async getSharedFiles({ commit }, page) {
      const { data } = await Api.get(`file-receives?page=${page}`)
      commit('clearFiles')
      commit('clearFilesMeta')

      if (data) {
        commit('setFiles', data.data)
        commit('setFilesMeta', data.meta)
      }
    }
  },

  getters: {
    files(state) {
      return state.files
    },
    filesMeta(state) {
      return state.filesMeta
    },
    file(state) {
      return state.file
    }
  }
}
